import { SVGProps } from 'react'

import ArrowLeft from '@interco/icons/build-v4/orangeds/MD/arrow-left'
import PdfFile from '@interco/icons/build-v4/orangeds/MD/pdf-file'
import ChevronRight from '@interco/icons/build-v4/orangeds/MD/chevron-right'
import Eua from '@interco/icons/build-v4/orangeds/MD/eua'
import Argentina from '@interco/icons/build-v4/orangeds/MD/argentina'
import Globe from '@interco/icons/build-v4/orangeds/MD/globe'
import Brasil from '@interco/icons/build-v4/orangeds/MD/brasil'
import FlashOn from '@interco/icons/build-v4/orangeds/MD/flash-on'
import Pending from '@interco/icons/build-v4/orangeds/MD/pending'
import ISafe from '@interco/icons/build-v4/orangeds/MD/i-safe'
import Canceled from '@interco/icons/build-v4/orangeds/MD/canceled'
import Copy from '@interco/icons/build-v4/orangeds/MD/copy'
import Share from '@interco/icons/build-v4/orangeds/MD/share'
import CheckFill from '@interco/icons/build-v4/orangeds/MD/check-fill'
import Close from '@interco/icons/build-v4/bidis/layout/close'

type IconThemeProps = SVGProps<SVGSVGElement> & {
  icon: string
}

const iconMap: Record<string, React.ComponentType<SVGProps<SVGSVGElement>>> = {
  'orangeds/MD/arrow-left': ArrowLeft,
  'orangeds/MD/pdf-file': PdfFile,
  'orangeds/MD/chevron-right': ChevronRight,
  'orangeds/MD/eua': Eua,
  'orangeds/MD/argentina': Argentina,
  'orangeds/MD/globe': Globe,
  'orangeds/MD/brasil': Brasil,
  'orangeds/MD/flash-on': FlashOn,
  'orangeds/MD/pending': Pending,
  'orangeds/MD/i-safe': ISafe,
  'orangeds/MD/canceled': Canceled,
  'orangeds/MD/copy': Copy,
  'orangeds/MD/share': Share,
  'orangeds/MD/check-fill': CheckFill,
  'bidis/layout/close': Close,
}

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use direct icon imports instead for better performance and type safety.
 *
 * @example
 * // Instead of: <IconTheme icon="orangeds/MD/arrow-left" />
 * // Use: import ArrowLeft from '@interco/icons/build-v4/orangeds/MD/arrow-left'
 * //      <ArrowLeft />
 */
export const IconTheme = ({ icon, ...rest }: IconThemeProps) => {
  const IconComponent = iconMap[icon]

  if (!IconComponent) {
    return null
  }

  return <IconComponent color="var(--primary500)" {...rest} />
}
